import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function AdminNotFoundLogs() {
    const [logs, setLogs] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch("/api/admin/not_found_logs")
            .then((res) => res.json())
            .then((data) => {
                setLogs(data);
                setLoading(false);
            });
    }, []);

    return (
        <div className="container mx-auto p-4">
            <h2 className="text-2xl font-bold mb-4">404-es oldalak statisztikája</h2>
            {loading ? (
                <div>Betöltés...</div>
            ) : (
                <Card>
                    <CardHeader>
                        <CardTitle>Leggyakrabban kért nem létező oldalak</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <table className="min-w-full text-sm">
                            <thead>
                                <tr>
                                    <th className="text-left">URL</th>
                                    <th>Darab</th>
                                    <th>Első</th>
                                    <th>Utolsó</th>
                                    <th>IP</th>
                                    <th>User-Agent</th>
                                </tr>
                            </thead>
                            <tbody>
                                {logs.map((row) => (
                                    <tr key={row.url}>
                                        <td className="break-all pr-2">{row.url}</td>
                                        <td className="text-center">{row.count}</td>
                                        <td>{row.first_seen ? new Date(Number(row.first_seen) * 1000).toLocaleString() : "-"}</td>
                                        <td>{row.last_seen ? new Date(Number(row.last_seen) * 1000).toLocaleString() : "-"}</td>
                                        <td>{row.last_ip}</td>
                                        <td className="break-all max-w-xs">{row.last_ua}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </CardContent>
                </Card>
            )}
        </div>
    );
}
